import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "loader-inline",
  "use": "loader-inline-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"loader-inline\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16m0 2c3.308 0 6 2.692 6 6s-2.692 6-6 6c-3.309 0-6-2.692-6-6s2.691-6 6-6\" fill=\"#6D7981\" /><path d=\"M12 6c3.308 0 6 2.692 6 6h2a8 8 0 0 0-8-8v2Z\" fill=\"#DBDEDF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol